import { Injectable } from '@angular/core'
import { BackOfficeConfig } from '../interfaces/back-office-config'
import { take } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { ConfigService } from './config.service'
@Injectable({
  providedIn: 'root',
})
export class SubscriptionCatalogService {
  targetStorage: string = ''
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig

  constructor(private http: HttpClient, private configService: ConfigService) {}

  initializeSubscriptionCatalog(): Promise<boolean> {
    this.backofficeConfig = this.configService.getBackOfficeConfig()
    this.targetStorage =
      this.backofficeConfig['FLEET_SUBSCRIPTION_TARGET_ON_LOCAL_STORAGE']
    switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
      case 'LOCAL':
        return this.initializeLocalSubscriptionCatalog()
      case 'BUCKET':
        return this.initializeBucketSubscriptionCatalog()
      case 'BACKOFFICE':
        return this.initializeBackOfficeSubscriptionCatalog(
          this.backofficeConfig
        )
      default:
        return new Promise<boolean>((resolve) => {
          resolve(false)
        })
    }
  }

  initializeLocalSubscriptionCatalog(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE
      this.http
        .get(`http://localhost:3000/getCatalog/${culture}`)
        .pipe(take(1))
        .subscribe((value) => {
          localStorage.setItem(this.targetStorage, JSON.stringify(value))
        })
      resolve(true)
    })
  }

  initializeBucketSubscriptionCatalog(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE
      this.http
        .get(`/fakeoffice/translations/translation_${culture}.json`)
        .pipe(take(1))
        .subscribe((value) => {
          localStorage.setItem(this.targetStorage, JSON.stringify(value))
        })
      resolve(true)
    })
  }

  initializeBackOfficeSubscriptionCatalog(
    backofficeConfig: any
  ): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      resolve(true)
    })
  }

  getProductCatalog(): Object {
    const translationFleet = JSON.parse(
      localStorage.getItem(this.targetStorage) + ''
    )
    return translationFleet
  }
}
